// @flow

import React from 'react';
import LabeledDropdown from '@active/awe-ui-core/lib/components/LabeledDropdown';
import EventHomeDropDownItems from 'type/type';
import classNames from 'classnames';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import DropdownGroup from '@active/awe-ui-core/lib/components/DropdownGroup';

import './FlexibleDropdown.scss';

type Props = {
  dropdownItems: EventHomeDropDownItems
}

const FlexibleDropdown = ({ dropdownItems }: Props) => {
  return (
    <DropdownGroup>
      {dropdownItems.map((item) => {
        const {
          itemClasses, label, data, value, onChange,
        } = item;

        if (!data) {
          return null;
        }

        switch (data.length) {
          case 0:
            return null;
          case 1:
            return (
              <div key={label} className={classNames(itemClasses, 'flexible-dropdown__filter-single')}>
                <span className="flexible-dropdown__filter-single-label">
                  <L10nMessage id={label} />
&nbsp;:
                </span>
                <span className="flexible-dropdown__filter-single-data">{data[0].text}</span>
              </div>
            );
          default:
            return (
              <LabeledDropdown
                className={classNames(itemClasses)}
                label={label}
                data={data}
                value={value}
                key={label}
                onChange={onChange} />
            );
        }
      })}
    </DropdownGroup>
  );
};

export default FlexibleDropdown;
